// extracted by mini-css-extract-plugin
module.exports = {"body":"BigButton_body__1kWYF","disabled":"BigButton_disabled__3amnW"};